// extracted by mini-css-extract-plugin
export default {"container":"LimitParticipant_container__kL-0W","label":"LimitParticipant_label__Gc0vL"};